/**
 * Inquiry-only products (TAG Heuer): the purchase buttons are hidden behind a
 * "Request to Purchase Online" button. Clicking it reveals the real Buy Now /
 * Add to Bag buttons in every location at once (main buy area, sticky bar,
 * mobile bar). The framing matters: purchase happens as fulfilment of the
 * customer's explicit request.
 */
document.addEventListener('click', (e) => {
  const target = e.target as HTMLElement;
  if (!target.closest('.js-request-purchase')) return;
  document.querySelectorAll<HTMLElement>('.js-request-purchase').forEach((btn) => {
    btn.style.display = 'none';
  });
  document.querySelectorAll<HTMLElement>('.js-purchase-actions').forEach((wrap) => {
    wrap.classList.remove('purchase-actions--hidden');
  });
});

export {};
